import { Directive, Optional } from "@angular/core";
import { RouterLink, UrlTree } from "@angular/router";
import { CustomQueryParams } from "../internals/custom-query-params";

@Directive({
    selector: '[routerLink][queryParams]',
    standalone: false
})
export class JsonQueryParamsDirective {
    
    private static originalUrlTreeFunc : () => UrlTree = Object.getOwnPropertyDescriptor(RouterLink.prototype, "urlTree").get;
    private static originalUrlTreeHrefFunc : () => UrlTree = Object.getOwnPropertyDescriptor(RouterLink.prototype, "urlTree").get;

    constructor(
        @Optional() private routerLink: RouterLink,
        @Optional() private routerLinkWithHref: RouterLink,
    ) {
            if (routerLink) {
                Object.defineProperty(this.routerLink, "urlTree", { get: JsonQueryParamsDirective.createUrlTree });    
        }
        else if (routerLinkWithHref) {
                Object.defineProperty(this.routerLinkWithHref, "urlTree", { get: JsonQueryParamsDirective.createUrlTreeHref });    
        }
        else {
                throw "No router link was injected";
        }        
    }
    
    private static createUrlTree() : UrlTree{
            const that = this as any;
        const urlTree = JsonQueryParamsDirective.originalUrlTreeFunc.call(that);
        if (that.queryParams) {
                urlTree.queryParams = CustomQueryParams.Create(that.queryParams);
        }
        return urlTree;
    }

    private static createUrlTreeHref() : UrlTree{
            const that = this as any;
        const urlTree = JsonQueryParamsDirective.originalUrlTreeHrefFunc.call(that);
        if (that.queryParams) {
                urlTree.queryParams = CustomQueryParams.Create(that.queryParams);
        }
        return urlTree;
    }
}